enum EppoFlags {
  SmokeTestFF = 'EzManage::SmokeTestFF',
  SmokeTestExperiment = 'EzManage::SmokeTestExperiment',
  SelfServePromoTool = 'EzManage::SelfServePromoTool',
  PromosReportingDashboard = 'SupplierMarketing::PromosReportingDashboard',
  CustomerEngagementChart = 'SupplierMarketing::CustomerEngagementChart',
  RockstarConvertsToRolling90Days = 'FX::RockstarConvertsToRolling90Days',
  DisallowItemDescriptionOnBrandIDs = 'EzManage::DisallowItemDescriptionOnBrandIDs',
  DisplayItemDescription = 'EzManage::DisplayItemDescription',
  RockstarPreview = 'FX::RockstarPreview',
  TurnOffIntegrationsPermission = 'EzManage::TurnOffIntegrationsPermission',
  PerformanceMetrics = 'SupplierMarketing::PerformanceMetrics',
  PerformanceMetricsCompareTo = 'SupplierMarketing::PerformanceMetricsCompareTo',
  ReadFromOrdersSdkForOrderDetails = 'SupplierSelfService::ReadFromOrdersSdkForOrderDetails',
  SponsoredPromoDetails = 'SupplierMarketing::SponsoredPromoDetails',
  DirectOnboarding = 'SupplierSelfService::DirectOnboarding',
  AdTargetingEngagementStatus = 'SupplierMarketing::AdTargetingEngagementStatus',
  PaymentDetailsImprovements = 'SupplierMarketing::PaymentDetailsImprovements',
  OrderAttributionDrawer = 'SupplierMarketing::OrderAttributionDrawer',
  EnableCancellationPolicyUIEzManage = 'FX::EnableCancellationPolicyUIEzManage',
  DeliveryPerformanceReportingV2 = 'Delivery::PerformanceReportingV2',
  DeliveryPerformanceDataDownload = 'Delivery::DeliveryPerformanceDataDownload',
  OrdersListImprovements = 'SupplierMarketing::OrdersListImprovements',
  CopyBusinessInfo = 'SupplierSelfService::DirectOnboardingCopyBusinessInfo',
  NewOrdersReports = 'SupplierMarketing::NewOrdersReports',
  GroupManagementRefresh = 'SupplierMarketing::GroupManagementRefresh',
  OpsMetricsRedesign = 'FX::OpsMetricsRedesign',
}

export default EppoFlags;
